







import Vue from "vue";
import {Component} from "vue-property-decorator";
import {AlertType} from "../model/enum/alert.enum";
import Alert from "./alert.vue";
import {MessageBus} from "../services/messageBus";
import {AlertData} from "../model/interface/alertData.interface";

@Component({
    components: {
        Alert
    }
})
export default class MessageComponent extends Vue {
    private alertDatas: AlertData[] = [];
    private id: number = 0;

    mounted() {
        MessageBus.$on(AlertType[AlertType.error], (message: string) => {
            this.id++;
            this.alertDatas.push( <AlertData> {
                    key: this.id,
                    msg: message,
                    type: AlertType.error,
                })
        });
        MessageBus.$on(AlertType[AlertType.warning], (message: string) => {
            this.id++;
            this.alertDatas.push( <AlertData> {
                key: this.id,
                msg: message,
                type: AlertType.warning,
            })
        });
        MessageBus.$on(AlertType[AlertType.success], (message: string) => {
            this.id++;
            this.alertDatas.push( <AlertData> {
                key: this.id,
                msg: message,
                type: AlertType.success,
            })
        });
    };
}

